import React, { createContext, ReactNode } from "react";
import { useFormWithSessionStorage } from "hooks/usePersistentData";
import { GeneralForm } from "components/pages/DhsPage/Forms/types";

interface MyContextProviderProps {
  children: ReactNode;
}

export interface StoreContextProps {
  data: GeneralForm | null;
  updateData: (
    newData: (prevData: GeneralForm | null) => GeneralForm | null,
  ) => void;
}

export const DataFormsContext = createContext<StoreContextProps>({
  data: null,
  updateData: () => {},
});

export const DataFormsProvider: React.FC<MyContextProviderProps> = ({
  children,
}) => {
  const [data, setData] = useFormWithSessionStorage<GeneralForm | null>(null);

  const updateData = (
    newData: (prevData: GeneralForm | null) => GeneralForm | null,
  ) => {
    setData(newData);
  };

  return (
    <DataFormsContext.Provider value={{ data, updateData }}>
      {children}
    </DataFormsContext.Provider>
  );
};
